// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import { InternalBaseComponentProps } from '../internal/hooks/use-base-component';
import { NavigableGroupProps } from './interfaces';

export interface InternalNavigableGroupProps extends NavigableGroupProps, InternalBaseComponentProps {}
